import React from "react";

const ContactUsDesktop = React.lazy(() => import("./ui/ContactUs"));

export const ContactUsPage = () => {
  return <ContactUsDesktop />;
};
